import localforage from "localforage";

const metaStore = localforage.createInstance({ name: "zmusic", storeName: "songs_meta" });
const blobStore = localforage.createInstance({ name: "zmusic", storeName: "songs_blob" });
const settingsStore = localforage.createInstance({ name: "zmusic", storeName: "settings" });

export async function getAllSongs() {
  const arr = [];
  await metaStore.iterate((v) => {
    arr.push(v);
  });
  return arr.sort((a, b) => a.createdAt - b.createdAt);
}

export async function saveSong(meta, blob) {
  await blobStore.setItem(meta.id, blob);
  await metaStore.setItem(meta.id, meta);
}

export async function getBlob(id) {
  return blobStore.getItem(id);
}

export async function deleteSong(id) {
  await metaStore.removeItem(id);
  await blobStore.removeItem(id);
}

export async function getSetting(key, fallback) {
  const v = await settingsStore.getItem(key);
  return v === null || v === undefined ? fallback : v;
}

export async function setSetting(key, value) {
  await settingsStore.setItem(key, value);
}

export async function storageEstimate() {
  if (navigator.storage && navigator.storage.estimate) {
    const { usage = 0, quota = 0 } = await navigator.storage.estimate();
    return { usage, quota };
  }
  return { usage: 0, quota: 0 };
}
